import React from 'react';
import './Marquee.css';

const items = [
  { icon: '🏠', text: 'Zero Brokerage Deals', color: '#FFD700' },
  { icon: '✅', text: 'RERA Approved Projects', color: '#00E5FF' },
  { icon: '💰', text: 'Easy Home Loan Assistance', color: '#69FF47' },
  { icon: '📍', text: 'Prime Location Properties', color: '#FF6B6B' },
  { icon: '🔑', text: 'Ready to Move In', color: '#FFD700' },
  { icon: '🏗️', text: 'Under Construction Deals', color: '#FF9F43' },
  { icon: '📉', text: 'Best Price Guaranteed', color: '#00E5FF' },
  { icon: '🌿', text: 'Gated Community Living', color: '#69FF47' },
  { icon: '🏊', text: 'World-Class Amenities', color: '#FF6B6B' },
  { icon: '📋', text: 'Free Legal Consultation', color: '#FF9F43' },
  { icon: '🚗', text: 'Dedicated Parking Space', color: '#FFD700' },
  { icon: '🔒', text: '24/7 Security & CCTV', color: '#00E5FF' },
  { icon: '🌇', text: 'Luxury Flats & Villas', color: '#FF6B6B' },
  { icon: '📞', text: 'Expert Agent Support', color: '#69FF47' },
  { icon: '🎁', text: 'Special Festive Offers', color: '#FF9F43' },
  { icon: '⚡', text: 'Fast Registration Process', color: '#FFD700' },
];

export default function Marquee() {
  return (
    <div className="marquee-wrapper">
      <div className="marquee-track">
        {/* Duplicate for seamless loop */}
        {[...items, ...items].map((item, i) => (
          <span className="marquee-item" key={i}>
            <span className="marquee-icon">{item.icon}</span>
            <span className="marquee-text" style={{ color: item.color }}>
              {item.text}
            </span>
            <span className="marquee-sep" style={{ color: item.color }}>◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
